import { PlayerSizesTypes } from '../../../common/store/store.types';
import {
  CONTROLS_BAR_HEIGHT,
  SEEK_BAR_HEIGHT_LARGE,
  SEEK_BAR_HEIGHT_MEDIUM,
  MORE_VIDEOS_EXTRA_LARGE_HEIGHT,
  MORE_VIDEOS_LARGE_HEIGHT,
} from '../../../common/utils/common.constants';

interface StylesObject {
  upNextContainerStyle: { [key: string]: any };
}

const upNextContainer = {
  pointerEvents: 'auto',
  display: 'block',
  right: '0',
  position: 'absolute',
  bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_LARGE}px`,
  medium: {
    bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_MEDIUM}px`,
  },
  endStateLargeWithMoreVideo: {
    bottom: `${MORE_VIDEOS_LARGE_HEIGHT + 8}px`,
  },
  endStateXLWithMoreVideo: {
    bottom: `${MORE_VIDEOS_EXTRA_LARGE_HEIGHT + 32}px`,
  },
  endState: {
    bottom: 'unset',
    right: 'unset',
  },
  hide: {
    display: 'none',
  },
};

export const getUpNextStyleObject = (playerSize: PlayerSizesTypes, showUpNext: boolean, isEndState: boolean, galleryView: boolean): StylesObject => {
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return ({
    upNextContainerStyle: [
      upNextContainer,
      mediumSize && upNextContainer.medium,
      largeSize && isEndState && galleryView && upNextContainer.endStateLargeWithMoreVideo,
      extraLargeSize && isEndState && galleryView && upNextContainer.endStateXLWithMoreVideo,
      isEndState && (!galleryView || mediumSize) && upNextContainer.endState,
      !showUpNext && upNextContainer.hide,
    ],
  });
};
